import React from 'react';
import { remCalc } from '../../../util/style-util';
import { makeStyles } from '@mui/styles';
import { white, resourceDarkGray } from '../../../styles/style-constants';
import { Resource } from 'types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';

type Props = {
  title: string;
  resource?: Resource;
  onClick: () => void;
};

function SupportVideoTile(props: Props) {
  const { title, onClick } = props;
  const { videoTile, videoBox, videoButton, videoTitle } = useStyles();

  return (
    <div className={videoTile}>
      <div className={videoBox} onClick={onClick}>
        <FontAwesomeIcon size="2x" className={videoButton} icon={faPlay} />
      </div>
      <div className={videoTitle}>{title}</div>
    </div>
  );
}

const useStyles = makeStyles(() => {
  return {
    videoTile: {
      backgroundColor: white,
      width: '350px',
      height: remCalc(250),
      padding: remCalc(13),
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      boxShadow: '0px 4px 4px 0px' + resourceDarkGray,
      border: remCalc(1) + ' solid' + resourceDarkGray,
      borderRadius: remCalc(3),
      cursor: 'pointer',
      userSelect: 'none',
      '&:hover': {
        transform: 'scale(1.05, 1.05)'
      }
    },

    videoBox: {
      backgroundColor: '#E8E8E8',
      borderColor: '#DBDBDB',
      borderStyle: 'solid',
      borderRadius: '4px',
      borderWidth: '1px',
      width: 320,
      height: 172
    },

    videoButton: {
      marginLeft: 152,
      marginTop: 68
    },

    videoTitle: {
      marginTop: 13,
      fontSize: 16,
      fontWeight: 400,
      textAlign: 'center'
    }
  };
});

export default SupportVideoTile;
